<!-- 节庆热点 -->
<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-row class="category-management__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>买家信息：</span>
          <el-input v-model="filter.phone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="6" :span="8">
          <span>充值时间：</span>
          <el-date-picker
            v-model="filter.dateTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>支付方式：</span>
          <el-select
            v-model="filter.payWay"
            placeholder="请输入"
            clearable
            filterable
          >
            <el-option
              v-for="item in payOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <!-- <el-button type="primary" @click="handleSell">发放国版币</el-button> -->
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
        >
          <el-table-column
            prop="orderNo"
            label="充值订单号"
            width="220"
          ></el-table-column>
          <el-table-column
            prop="orderContent"
            label="充值内容"
          ></el-table-column>
          <el-table-column prop="payCount" label="支付金额">
            <template slot-scope="scope"> ￥{{ scope.row.payCount }} </template>
          </el-table-column>
          <el-table-column prop="orderStatus" label="支付状态">
            <template slot-scope="scope">
              {{ scope.row.orderStatus == "PAID" ? "已完成" : "待付款" }}
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付方式">
            <template slot-scope="scope">
              <span v-if="scope.row.payType == 'ALIPAY'">支付宝</span>
              <span v-else-if="scope.row.payType == 'WXPAY'">微信支付</span>
              <span v-else-if="scope.row.payType == 'OFFLINEPAY'">线下</span>
            </template>
          </el-table-column>
          <el-table-column prop="paidTime" label="充值时间">
            <template slot-scope="scope">
              {{ formatTime(scope.row.paidTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0" class="status-text"
                >正常</span
              >
              <span v-else-if="scope.row.status === 1" class="status-text"
                >已失效</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                class="edit"
                type="text"
                @click="handleDetail(scope.row.id, scope.row.orderNo)"
                >详情</el-button
              >
              <el-button
                v-if="
                  scope.row.status == 0 && scope.row.payType == 'OFFLINEPAY'
                "
                class="edit"
                type="text"
                @click="handleInvalid(scope.row.id)"
                >失效</el-button
              >
              <!-- <el-button class="edit" type="text" @click="handleDetail(scope.row.id)">失效</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
    <nationalVersionForm
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
    ></nationalVersionForm>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import { rechargeRecord } from "@/api/package";
import { expirePay } from "@/api/menu";
import { scope } from "@/config/config";
import dayjs from "dayjs";
import nationalVersionForm from "./nationalVersionForm.vue";
export default {
  components: {
    PageTitle,
    CusPagination,
    nationalVersionForm,
  },
  data() {
    return {
      apiEnd: false,
      loading: true,
      filter: {
        phone: "",
        dateTime: [],
        payWay: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
      currentData: {}, // 当前表单数据
      payOptions: [
        {
          value: "WXPAY",
          label: "微信",
        },
        {
          value: "ALIPAY",
          label: "支付宝",
        },
        {
          value: "OFFLINEPAY",
          label: "线下",
        },
      ],
      dialogVisible: false,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    async getList() {
      this.loading = true;
      const { data } = await this.$ajax.get(rechargeRecord, {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        phone: this.filter.phone,
        payWay: this.filter.payWay,
        startDate: this.filter.dateTime ? this.filter.dateTime[0] : "",
        endDate: this.filter.dateTime ? this.filter.dateTime[1] : "",
      });

      this.tableData = data?.rows || [];
      this.total = data?.total || 0;
      this.loading = false;
    },
    search() {
      this.getList();
    },
    reset() {
      this.filter.name = "";
      this.filter.dateTime = [];
      this.filter.payWay = "";
      this.filter.phone = "";
      this.getList();
    },
    handleDetail(id, invoiceCode) {
      this.$router.push({
        path: "/rechargeRecordDetail",
        query: { id, invoiceCode },
      });
    },
    handleSell() {
      this.dialogVisible = true;
    },
    formatTime(time) {
      return time ? dayjs(time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    async handleInvalid(id) {
      try {
        await this.$confirm(
          "设置失效后，用户的国版币将减去该国版币。",
          "失效",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        await this.$ajax.get(expirePay(id));
        this.$message.success("操作成功");
        this.getList();
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error("操作失败");
        }
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
